import React from 'react'
import { buildAverageValue } from './charts/fundingSeries'

interface MiniBarChartProps {
  data?: number[]
  showAverage?: boolean
  className?: string
}

export const MiniBarChart: React.FC<MiniBarChartProps> = ({
  data = [12, 18, 28, 64, 80, 43, 52, 66, 40, 58, 50, 68, 56, 72, 34],
  showAverage = true,
  className,
}) => {
  const barsBaseY = 124
  const barsHeight = 102
  const avg = buildAverageValue(data)
  const avgY = Math.round(barsBaseY - (avg / 100) * barsHeight)

  return (
    <div className={`absolute right-0 top-0 h-[124px] w-[185px] overflow-hidden ${className || ''}`}>
      <div className="absolute bottom-0 left-0 flex h-[102px] w-[185px] items-end gap-[5px]">
        {data.map((height, index) => (
          <div
            key={index}
            className="w-[7px] shrink-0 rounded-t-[4px] bg-gradient-to-b from-[rgba(197,204,159,0.55)] to-[rgba(197,204,159,0.18)]"
            style={{ height: `${Math.max(10, Math.min(94, height))}px` }}
          />
        ))}
      </div>

      {showAverage && (
        <>
          <svg className="pointer-events-none absolute inset-0 h-full w-full" viewBox="0 0 185 124" fill="none">
            <line x1="0" y1={avgY} x2="185" y2={avgY} stroke="#313131" strokeOpacity="0.72" strokeWidth="1.5" strokeDasharray="3 3" />
          </svg>

          <div className="absolute left-[2px]" style={{ top: `${Math.max(10, avgY - 10)}px` }}>
            <div className="flex items-start">
              <div className="rounded-l-[4px] rounded-br-[4px] bg-[#313131] px-[4px] py-px">
                <p className="font-plus-jakarta text-[13px] leading-[18px] text-white">Avg</p>
              </div>
              <div className="h-0 w-0 border-b-[10px] border-l-[10px] border-t-[10px] border-b-transparent border-l-[#313131] border-t-transparent" />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default MiniBarChart
